import React from 'react';
import { useTranslation } from 'react-i18next';
import './WizardSuggestionTag.scss';

interface WizardSuggestionTagProps {
  value: string;
  onApply: (value: string) => void;
}

// The "Suggested:" label is a bare text node (not a <span>): the wizard form styles every span as a
// red validation message (.project-wizard__form span), so a span here would turn red and break layout.
const WizardSuggestionTag: React.FC<WizardSuggestionTagProps> = ({ value, onApply }) => {
  const { t } = useTranslation();

  return (
    <div className="wizard-suggestion-row">
      {t('suggested')}:
      <button type="button" className="wizard-suggestion" onClick={() => onApply(value)}>
        {value}
      </button>
    </div>
  );
};

export default WizardSuggestionTag;
